import { useEffect, useRef } from "react";
import { IMAGE_BASE, NoImage } from "./constants";

export const checkAccess = (path, access, customPath) => {
  if (
    !customPath ? access[`${location.pathname}/${path}`] : access[`${path}`]
  ) {
    return true;
  }
  return false;
};

export const checkAccessList = (pathName, access) => {
  return access[pathName] || false;
};

export const errorBuildLvl1 = (errors) => {
  return (
    errors &&
    errors.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.context.key]: curr.message.replace(/[/"_]/g, " "),
      }),
      {}
    )
  );
};

export const returnImgSrc = (imgObj, size) => {
  if (imgObj && `path` in imgObj) {
    if (size) {
      return `${IMAGE_BASE}${imgObj.path.replace("public", `public/${size}`)}`;
    }
    return `${IMAGE_BASE}${imgObj.path}`;
  } else {
    return NoImage;
  }
};

export const windowEncoder = (value) => window.btoa(value);
export const windowDecoder = (value) => window.atob(value);

export const validator = (schema, validateObj) => {
  const error = buildUsefulError(validateObj, schema);
  return error || null;
};

export function reduceArr(arr, currKey) {
  return arr.reduce(
    (acc, curr) => ({ ...acc, [`${curr[currKey || "value"]}`]: curr }),
    {}
  );
}

export const buildUsefulError = (body, validateSchema) => {
  function validate(errors) {
    let sendObject = {};
    if (errors) {
      let errorProcess = errors.detail
        ? errors.detail
        : errors.details
          ? errors.details
          : errors;
      errorProcess.forEach((detail) => {
        let msg = `${detail.message.replace(/['"]/g, "")}`;
        if (detail.path.length > 1) {
          const keys = detail.path;
          let ref = sendObject;
          for (let i = 0; i < keys.length; i++) {
            let k = keys[i];
            if (!ref[k]) {
              if (Number.isInteger(keys[i + 1])) {
                ref[k] = [];
              } else {
                ref[k] = {};
              }
            }
            if (Number.isInteger(keys[i])) {
              if (i === keys.length - 1) {
                if (Array.isArray(ref[k])) {
                  ref[k].push(msg);
                } else {
                  ref[k] = [msg];
                }
              } else {
                ref = ref[k];
              }
            } else {
              if (i === keys.length - 1) {
                ref[k] = msg;
              } else {
                ref = ref[k];
              }
            }
          }
        } else {
          sendObject[detail.path[0]] = msg;
        }
      });
    }
    return sendObject;
  }

  const validation = validateSchema.validate(body, {
    abortEarly: false,
  });
  if (validation.error) {
    const errors = validation.error ? validate(validation.error.details) : null;
    return errors;
  } else {
    return null;
  }
};

export const useRenderCount = () => {
  const rendersNo = useRef(0);
  useEffect(() => {
    rendersNo.current++;
  }, []); // Empty dependency array to avoid infinite loops

  return rendersNo.current;
};

export const getLocalStorageValue = (key, isStrigified) => {
  const value = localStorage.getItem(key);
  if (value) {
    if (isStrigified) {
      return JSON.parse(value);
    } else {
      return value;
    }
  }
  return null;
};

export const setLocalStorageValue = (key, value, isStrigified) => {
  if (isStrigified) {
    const strigified = JSON.stringify(value);
    localStorage.setItem(key, strigified);
  } else {
    localStorage.setItem(key, value);
  }
};

export const setStorageValue = (key, value, isStringified, role) => {

  const storage = role === "6668174777d920ef32e6b9a3" ? sessionStorage : localStorage;

  if (isStringified) {
    storage.setItem(key, JSON.stringify(value));
  } else {
    storage.setItem(key, value);
  }
};

export const getStorageValue = (key, isStringified, role) => {
  const storage = role === "6668174777d920ef32e6b9a3" ? sessionStorage : localStorage;
  const value = storage.getItem(key);

  if (value) {
    return isStringified ? JSON.parse(value) : value;
  }
  return null;
};

export const getCombinedStorageValue = (key, isStringified) => {
  let value = localStorage.getItem(key);
  if (!value) {
    value = sessionStorage.getItem(key);
  }
  if (value) {
    return isStringified ? JSON.parse(value) : value;
  }
  return null;
};

export function capitalizeFirstLetter(string) {
  if (!string) return string; // Check for empty or undefined string
  return string.charAt(0).toUpperCase() + string.slice(1);
}
